/*!custom-title-fix.js
  Fix: produce text nodes + <br>, observer robusto, marca nodi già trasformati.
  Espone: window.__CTF_runOnce(), window.__CTF_disconnect()
*/
(() => {
  'use strict';

  const TITLE = 'a.grid-view-item__title';
  const MARK_ATTR = 'data-ctf-replaced';
  const SRCS = ['.collection', '.collection__grid', '.product-grid', '.grid'];
  const SEP_RE = /\s*[–—−-]\s*/;
  const D = document;
  const HEAD = D.head || D.documentElement;
  const DELAY_MS = 700;
  const markedSet = new WeakSet();

  const now = () => (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();

  const isFirstCollectionPage = () => {
    try {
      const p = new URLSearchParams(location.search);
      if (p.has('page')) return p.get('page') === '1';
      const m = location.pathname.match(/\/page\/(\d+)(?:\/|$)/);
      return !m || m[1] === '1';
    } catch (e) { return true; }
  };

  const markNode = n => {
    try { n.setAttribute(MARK_ATTR, '1'); } catch (e) {}
    try { markedSet.add(n); } catch (e) {}
  };
  const isMarked = n => markedSet.has(n) || (n && n.getAttribute && n.getAttribute(MARK_ATTR) === '1');

  const escapeHtml = s => String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');

  // costruisce frammento con text nodes + <br>
  const buildTextAndBrFromParts = parts => {
    const frag = D.createDocumentFragment();
    for (let i = 0; i < parts.length; i++) {
      frag.appendChild(D.createTextNode(parts[i]));
      if (i < parts.length - 1) frag.appendChild(D.createElement('br'));
    }
    return frag;
  };

  // se il nodo contiene già <br> o elementi ctf-line, consideralo trasformato (ma assicurati di marcare)
  const nodeAlreadySplit = node => {
    if (!node) return false;
    // presenza di <br> diretti o di elementi con classe ctf-line
    if (node.querySelector && (node.querySelector('br') || node.querySelector('.ctf-line'))) return true;
    // anche se textContent contiene sep ma figli sono elementi, fallback false (verrà ricostruito)
    return false;
  };

  // trasforma solo textNodes che contengono il separatore; fallback su fullText
  const transformNode = node => {
    if (!node || node.nodeType !== 1 || isMarked(node)) return false;
    if (typeof node.matches !== 'function' || !node.matches(TITLE)) { markNode(node); return false; }

    // se già splittato (es. <br> o .ctf-line) marca e ritorna true per i test
    if (nodeAlreadySplit(node)) { markNode(node); return true; }

    const fullText = (node.textContent || '').trim();
    if (!fullText || !SEP_RE.test(fullText)) { markNode(node); return false; }

    let changed = false;
    // itera sui textNodes diretti
    for (let cn = node.firstChild; cn; cn = cn.nextSibling) {
      if (cn.nodeType === 3 && cn.textContent && SEP_RE.test(cn.textContent)) {
        const parts = cn.textContent.split(SEP_RE);
        const frag = buildTextAndBrFromParts(parts);
        cn.parentNode.replaceChild(frag, cn);
        changed = true;
      }
    }

    if (!changed) {
      // fallback: ricostruisce da fullText con escape (solo se necessario)
      const parts = fullText.split(SEP_RE);
      const frag = buildTextAndBrFromParts(parts.map(p => escapeHtml(p)));
      while (node.firstChild) node.removeChild(node.firstChild);
      node.appendChild(frag);
      changed = true;
    }

    if (changed) markNode(node);
    return changed;
  };

  const replaceTitles = root => {
    if (!root || !root.querySelectorAll) return 0;
    const nodes = root.querySelectorAll(TITLE);
    let c = 0;
    for (let i = 0; i < nodes.length; i++) if (transformNode(nodes[i])) c++;
    return c;
  };

  // API per QA
  window.__CTF_runOnce = () => {
    const t0 = now();
    if (!isFirstCollectionPage()) return { changed: 0, durationMs: Math.round(now() - t0) };
    let container = null;
    for (let i = 0; i < SRCS.length; i++) {
      const el = D.querySelector(SRCS[i]);
      if (el) { container = el; break; }
    }
    container = container || D.body || D;
    let changed = replaceTitles(container);
    if (container !== D && container !== D.body) changed += replaceTitles(D);
    return { changed, durationMs: Math.round(now() - t0) };
  };

  if (!isFirstCollectionPage()) return;

  // determina container preferito (fallback body)
  let container = null;
  for (let i = 0; i < SRCS.length; i++) {
    const el = D.querySelector(SRCS[i]);
    if (el) { container = el; break; }
  }
  container = container || D.body || D;

  // inietta CSS minimo (una sola volta)
  try {
    const styleId = 'ctf-style';
    if (!D.getElementById(styleId)) {
      const s = D.createElement('style');
      s.id = styleId;
      s.textContent = `a.grid-view-item__title[${MARK_ATTR}="1"]{white-space:normal!important;display:block!important;word-break:break-word;}`;
      HEAD.appendChild(s);
    }
  } catch (e) {}

  // initial pass post-paint
  const doInitial = () => {
    replaceTitles(container);
    if (container !== D && container !== D.body) replaceTitles(D);
  };
  if (D.readyState === 'complete') requestAnimationFrame(() => requestAnimationFrame(doInitial));
  else {
    window.addEventListener('load', () => requestAnimationFrame(() => requestAnimationFrame(doInitial)), { once: true });
    window.addEventListener('DOMContentLoaded', () => requestAnimationFrame(doInitial), { once: true });
  }

  // delayed pass per renderer tardivi
  setTimeout(() => { replaceTitles(container); if (container !== D && container !== D.body) replaceTitles(D); }, DELAY_MS);

  // batching via rAF
  let scheduled = false;
  const schedule = maybeRoot => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      if (maybeRoot && maybeRoot.nodeType === 1) {
        if (typeof maybeRoot.matches === 'function' && maybeRoot.matches(TITLE)) transformNode(maybeRoot);
        replaceTitles(maybeRoot);
      }
      replaceTitles(container);
      scheduled = false;
    });
  };

  // observer robusto: non ritorna al primo match, scorre tutte le mutazioni e schedule una volta
  const mo = new MutationObserver(mutations => {
    let shouldSchedule = false;
    for (let i = 0; i < mutations.length; i++) {
      const m = mutations[i];
      const added = m.addedNodes;
      if (added && added.length) {
        for (let j = 0; j < added.length; j++) {
          const n = added[j];
          if (!n || n.nodeType !== 1) continue;
          try {
            if ((typeof n.matches === 'function' && n.matches(TITLE)) || (n.querySelector && n.querySelector(TITLE))) {
              shouldSchedule = true;
              // non return: vogliamo valutare tutte le mutazioni prima di schedule
            }
          } catch (e) {}
        }
      }
      if ((m.removedNodes && m.removedNodes.length) || m.type === 'characterData') {
        shouldSchedule = true;
      }
    }
    if (shouldSchedule) schedule(D.body);
  });

  try { mo.observe(container, { childList: true, subtree: true }); }
  catch (e) { try { mo.observe(D.body || D, { childList: true, subtree: true }); } catch (e2) {} }

  window.__CTF_disconnect = () => { try { mo.disconnect(); } catch (e) {} };
})();
